// extracted by mini-css-extract-plugin
module.exports =  {"container":"b429494557--container--TlfVw","image":"b429494557--image--kQ5dV","description":"b429494557--description--Y970l"};